import awsmobile from '@/aws-exports';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { memo, useEffect, useState } from 'react';

function getImageSrc(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    const img = doc.querySelectorAll("img");
    const imgSrcList = [];
    if (img) {
        doc.querySelectorAll('img').forEach((imgElement) => {
        imgSrcList.push(imgElement.getAttribute('src'));
        });
    }
    return imgSrcList;
}

const replaceOldLinkImg = defaultValue => {
    let stringCopy = (' ' + defaultValue).slice(1);

    let imgSrcList = getImageSrc(defaultValue);

    if(Utils.isEmptyArray(imgSrcList)) {
        return stringCopy;
    }

    for (let i = 0; i < imgSrcList.length; i++) {
        let indexOfImage = imgSrcList[i].indexOf(
            `https://${awsmobile.aws_user_files_s3_bucket}.s3`
        );

        if (indexOfImage !== -1) {
            const startStr = '/public/';
            const endStr = '?';

            const startIndex = imgSrcList[i].indexOf(startStr) + startStr.length;
            const endIndex = imgSrcList[i].indexOf(endStr, startIndex);

            const resultKey = imgSrcList[i].substring(startIndex, endIndex);

            let fileUpload = {
                fileUrl: resultKey,
                type: Constant.S3_FILE_TYPE.TICKET_FILE
            }
            let link = getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
            let linkNeedReplace = `\\"${link}\\"`;
            stringCopy = stringCopy.replace(imgSrcList[i], linkNeedReplace);
        }
    }
    return stringCopy;
};

function FreeMessage({message,isMaximizedPanel}) {
    const [messageState, setMessagesState] = useState(message)
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [htmlContent, setHtmlContent] = useState(draftToHtml(convertToRaw(editorState.getCurrentContent())))

    useEffect(() => {
        let contentFreeMessage = replaceOldLinkImg(messageState?.content[0])
        contentFreeMessage = contentFreeMessage === 'undefined' ? '' : contentFreeMessage
        setEditorState(contentFreeMessage
            ? EditorState.createWithContent(
                  ContentState.createFromBlockArray(htmlToDraft(JSON.parse(contentFreeMessage)))
              )
            : EditorState.createEmpty())
    },[messageState]);

    useEffect(() => {
        setHtmlContent(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    },[editorState]);
    return (
        <div className={isMaximizedPanel ? 'message-text message-text-maximized-freemsg' : 'message-text message-text-freemsg'}>
            <div className="text-question text-question-freemsg" id={messageState.idMessage}><div dangerouslySetInnerHTML={{__html: htmlContent}}></div></div>
        </div>
    );
}

export default memo(FreeMessage);